var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#FBF5EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9102 41.4167C19.9102 40.9217 20.6392 33.1187 20.6392 33.1187L25.8997 29.6807",
    stroke: "#F5B335",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8945 29.6807L26.4255 36.1247L29.499 33.4472L25.8945 29.6807Z",
    stroke: "#F5B335",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7711 36.5254L27.5156 41.4169",
    stroke: "#F5B335",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0891 41.4167C39.0891 40.9217 38.3601 33.1187 38.3601 33.1187L33.0996 29.6807",
    stroke: "#F5B335",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1045 29.6807L32.5735 36.1247L29.5 33.4472L33.1045 29.6807Z",
    stroke: "#F5B335",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4993 33.4473L27.8613 34.8783L28.7703 36.5208H29.4993H30.2283L31.1373 34.8783L29.4993 33.4473Z",
    stroke: "#F5B335",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2285 36.5254L31.484 41.4169",
    stroke: "#F5B335",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1055 38.3213H35.9135",
    stroke: "#F5B335",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3258 24.2765C33.3258 21.6845 31.6113 19.583 29.5008 19.583C27.3903 19.583 25.6758 21.6845 25.6758 24.2765C25.6758 26.8685 27.3903 28.9745 29.5008 28.9745C31.6113 28.9745 33.3258 26.873 33.3258 24.2765Z",
    stroke: "#F5B335",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2754 33.1913L41.8079 30.8828",
    stroke: "#F5B335",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2321 33.4163L41.8066 30.8828",
    stroke: "#F5B335",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8755 39.7476C50.8755 39.4146 50.2005 33.2001 50.2005 33.2001L46.668 30.8916",
    stroke: "#F5B335",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6534 30.8828L44.2324 33.4163V38.3213",
    stroke: "#F5B335",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2336 30.4057C45.6527 30.4057 46.8031 28.9934 46.8031 27.2512C46.8031 25.509 45.6527 24.0967 44.2336 24.0967C42.8145 24.0967 41.6641 25.509 41.6641 27.2512C41.6641 28.9934 42.8145 30.4057 44.2336 30.4057Z",
    stroke: "#F5B335",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7259 33.1913L17.1934 30.8828",
    stroke: "#F5B335",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7676 33.4163L17.1931 30.8828",
    stroke: "#F5B335",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 39.7476C8.125 39.4146 8.8 33.2001 8.8 33.2001L12.3325 30.8916",
    stroke: "#F5B335",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3457 30.8828L14.7667 33.4163V38.3213",
    stroke: "#F5B335",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7668 30.4057C16.1859 30.4057 17.3363 28.9934 17.3363 27.2512C17.3363 25.509 16.1859 24.0967 14.7668 24.0967C13.3477 24.0967 12.1973 25.509 12.1973 27.2512C12.1973 28.9934 13.3477 30.4057 14.7668 30.4057Z",
    stroke: "#F5B335",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.504ee18bb1fa438356e0c5addc73829c.svg";
export { ForwardRef as ReactComponent };